export default __webpack_public_path__ + "static/media/profile-pic.5a198b3f.svg";